<template>
  <div class="vtitle" >
    <span class="title">{{pageTitle}}</span>
  </div>
</template>

<script>
export default {
  name: 'vtitle',
  props: [
    'pageInfo'
  ],
  computed: {
    pageTitle: function () {
      console.log('======watch init=====')
      let url = '';
      if ((this.pageInfo != null) && (this.$store.getters.getAppId > -1) && (this.$store.getters.getPageId > -1)) {
        var appId = this.$store.getters.getAppId
        var pageId = this.$store.getters.getPageId
        url = this.pageInfo[0].subMenu[pageId].title
      }
      return url
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vtitle {
  text-align: left;
  padding: 0.5em;
}
.title {
    color: #144a74;
    font-size: x-large;
    font-weight: bold;
    min-height: 20px;
    padding: 0.1em 0.2em; 
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
}
</style>



// WEBPACK FOOTER //
// src/components/common/TitlePage.vue